export default {
  paper: {
    banner: 'paper',
    title: 'PWmat related literature',
    titleP1: 'In the following table, we list the literature related to PWmat for user research reference:',
    year: '',
  }
}